
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.906 2.25h-3.094v-.563C11.813.756 11.057 0 10.126 0h-2.25c-.932 0-1.688.756-1.688 1.688v.562H3.095c-.777 0-1.406.63-1.406 1.406v1.125c0 .31.251.563.562.563h13.5c.31 0 .563-.252.563-.563V3.656c0-.776-.63-1.406-1.407-1.406zm-7.594-.563c0-.31.253-.562.563-.562h2.25c.31 0 .563.252.563.563v.562H7.312v-.563zM2.755 6.469c-.1 0-.18.084-.176.184l.464 9.74A1.685 1.685 0 004.73 18h8.542c.902 0 1.643-.706 1.685-1.607l.465-9.74a.176.176 0 00-.176-.184H2.755zm8.495 1.406a.562.562 0 111.125 0v7.313a.562.562 0 11-1.125 0V7.875zm-2.813 0a.562.562 0 111.125 0v7.313a.562.562 0 11-1.125 0V7.875zm-2.812 0a.562.562 0 111.125 0v7.313a.562.562 0 11-1.125 0V7.875z","fill":"#B1B7C7"}})])
          )
        }
      }
    